<template>
  <div class="fl-sym-px-4">
    <div

        class="fl-sym-mt-20 fl-sym-text-dark-blue fl-sym-text-xxs"

    >
      LOG IN
    </div>
    <div

        class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-bold fl-sym-mb-2 fl-sym-letter-space-minus-02"
    >
      Welcome back
    </div>
    <div class="fl-sym-text-intermediate fl-sym-text-lg">
      Sign in to continue
    </div>
    <form

        class="fl-sym-mt-20"
        @submit.prevent="submit"
        method="post"
    >
      <div class="fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-px-4 fl-sym-py-4 " id="email-section" @click="inputStylingEmail">
        <label class="email-password-label" for="email">Email</label>
        <input

            id="email"
            type="email"
            placeholder="Email"
            required
            v-model="email"
            name="login_input"
            class="login-email fl-sym-w-full fl-sym-text-lg fl-sym-mb-1 focus:fl-sym-outline-none focus:fl-sym-border-secondary fl-sym-placeholder-graduate"
        />
      </div>
      <div v-if="errors">
          <img src="@/assets/Error-icon.svg" width="13" class="error-icon" v-if="errors.email"/><span class="error" v-if="errors.email">{{ errors.email }}</span>
        </div>
      <div class="fl-sym-rounded fl-sym-border fl-sym-border-graduate fl-sym-px-4 fl-sym-py-4 fl-sym-mt-8" id="password-section" @click="inputStylingPassword">
        <label class="email-password-label" for="password">Password</label>
        <input

            placeholder="Password"
            id="password"
            required
            type="password"
            name="password_input"
            v-model="password"
            class="login-password fl-sym-w-full fl-sym-text-lg fl-sym-mb-1 focus:fl-sym-outline-none fl-sym-placeholder-graduate"
       />
      </div>
        <div v-if="errors">
          <img src="@/assets/Error-icon.svg" width="13" class="error-icon" v-if="errors.password"/> <span class="error" v-if="errors.password">{{ errors.password }}</span>

        </div>
      <div v-if="errors">
        <span class="error" v-if="errors.non_field_errors">{{
          errors.non_field_errors[0]
        }}</span>
      </div>
      <div

          class="fl-sym-text-right fl-sym-text-dark-blue fl-sym-text-xs fl-sym-mt-1"
          style="cursor: pointer"
          @click="forgetPassword"
      >
        Forgot password?
      </div>
      <div class="fl-sym-mt-20 fl-sym-mb-2">
        <button

            type="submit"
            class="button-blue-gradient hover:fl-sym-text-opacity-75 fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
        >
          Log in
        </button>
      </div>

      <div class="fl-sym-flex fl-sym-justify-center fl-sym-text-sm fl-sym-font-bold fl-sym-mt-4">
        <router-link class="link" :to="{ name: 'register-step-1' }">
          <div class="fl-sym-text-intermediate fl-sym-mr-1">Need an account?</div>
        <div class="fl-sym-text-dark-blue">

          Create it now </div>
          </router-link>
      </div>
    </form>
  </div>
</template>

<script>
// REMINDER - double check to see who put these here
//          and if they mean to use them for something
//          don't just delete them
// import * as openModel from "../../gen/openapi-js/dist/index"
// import RestAuthApi from "../../gen/openapi-js/dist/api/RestAuthApi"
import { mapState } from "vuex"
import { UserLogin } from "@/gen/openapi-js/src"

export default {
  name: "login",
  data() {
    return {
      email: "",
      password: "",
      display: "none",
    }
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
  },
  methods: {
    forgetPassword() {
      this.$router.push({ name: process.env.VUE_APP_AUTH_FORGET_PASSWORD })
    },
    async submit() {
      await this.$store.dispatch(
        "auth/login",
        new UserLogin(this.email, this.password)
      )
    },
    inputStylingPassword() {
    document.getElementById("password-section").classList.add("text-decrease");
    document.getElementById("password-section").classList.add("text-size");
    document.getElementById("password-section").classList.remove("fl-sym-py-4");
    document.getElementById("password-section").classList.add("fl-sym-py-1");
      document.getElementById("password-section").focus();
      document.getElementById("password").classList.add("input-fade");
    document.getElementById("password").focus();
    },
    inputStylingEmail() {
    document.getElementById("email-section").classList.add("text-decrease");
    document.getElementById("email-section").classList.add("text-size");
    document.getElementById("email-section").classList.remove("fl-sym-py-4");
    document.getElementById("email-section").classList.add("fl-sym-py-1");
      document.getElementById("email-section").focus();
        document.getElementById("email").classList.add("input-fade");
    document.getElementById("email").focus();
    },
  },
}
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 12px;
  line-height: 16px;
  color: #ff3a19;
}

.border-red {
  border-color: #ff3a19!important;
}
.login-password,.login-email {
  display:none;
  letter-spacing: 0.56px;
  color: #6F7878;
  opacity: 1;
  font-size: 17px;
  line-height: 22px;

}
.email-password-label {
  text-align: left;
letter-spacing: 0.56px;
color: #6F7878;
}
.text-decrease {
  animation: textshrink 0.8s ease-in-out;
  font-size: 12px;
  letter-spacing: 0.4px;
}

@keyframes textshrink {
    0% {
    font-size: 16px;
    }
    100% {
    font-size: 12px;
      letter-spacing: 0.4px;
    }
}
.input-fade {
  animation: inputfadein 1s ease-in-out;
  display: block;

}
@keyframes inputfadein {
    0% {
      opacity: 0;
      display: block;
    }
    100% {
    opacity: 1;
    }
}
  #password-section:focus-within, #email-section:focus-within {
    border: #00C8E3 solid 2px;
}
  input[type=password] {
  font-weight: 100;
  font: menu;
  letter-spacing: 4px;
  font-family: 'SF Pro Display Regular'!important;
  padding-top: 6px;
}
  input[type=password]::placeholder {
  color: #D0DADA;
    font-size: 17px;
    line-height: 22px;
    text-align: left;
    letter-spacing: 0.56px;
}
  a.link {
    display: contents;
}
</style>
